/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AskUserQuestionMultipleChoice } from "./AskUserQuestionMultipleChoice";
import type { AskUserQuestionOneOfTwo } from "./AskUserQuestionOneOfTwo";
import type { AskUserQuestionPhotoUpload } from "./AskUserQuestionPhotoUpload";
import type { AskUserQuestionScale } from "./AskUserQuestionScale";
import type { AskUserQuestionSingleChoice } from "./AskUserQuestionSingleChoice";
import type { AskUserQuestionYesOrNo } from "./AskUserQuestionYesOrNo";

export interface AskUserQuestionsContent {
  questions: (
    | AskUserQuestionMultipleChoice
    | AskUserQuestionSingleChoice
    | AskUserQuestionOneOfTwo
    | AskUserQuestionYesOrNo
    | AskUserQuestionScale
    | AskUserQuestionPhotoUpload
  )[];
}
